// eslint-disable-next-line
export default {
   'program.export': 'Export',
   'program.date': 'Date',
   'program.planName': 'Plan de lealtad',
   'program.id': 'ID',
}
